import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContainerComponent } from '../../layout/container/container.component';
import { advanceCard, caracteristicasAvance, superAdvanceCard } from './data/product-cards.data';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-product-cards',
  standalone: true,
  imports: [CommonModule, RouterModule, ContainerComponent],
  templateUrl: './product-cards.component.html',
  styleUrls: ['./product-cards.component.scss']
})
export class ProductCardsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('productCards', { static: false }) productCards?: ElementRef;
  caracteristicasAvance = caracteristicasAvance;
  advanceCard = advanceCard;
  superAdvanceCard = superAdvanceCard;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.productCards?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.productCards.nativeElement,
        'Product Cards',
        'product-cards-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

  // Método para trackear click en CTA de Avance
  onAdvanceCTAClick(): void {
    this.analyticsService.trackCTAClick(
      this.advanceCard.ctaText,
      'Product Cards - Avance',
      'button',
      {
        product_type: 'avance',
        cta_url: this.advanceCard.ctaLink
      }
    );
  }

  // Método para trackear click en CTA de Súper Avance
  onSuperAdvanceCTAClick(): void {
    this.analyticsService.trackCTAClick(
      this.superAdvanceCard.ctaText,
      'Product Cards - Súper Avance',
      'button',
      {
        product_type: 'super_avance',
        cta_url: this.superAdvanceCard.ctaLink
      }
    );
  }

  // Método para trackear click en bases legales de Avance
  onAdvanceLegalClick(): void {
    this.analyticsService.trackLinkClick(
      'Revisar bases legales - Avance',
      this.advanceCard.legalLink,
      'Product Cards - Avance',
      false
    );
  }

  // Método para trackear click en bases legales de Súper Avance
  onSuperAdvanceLegalClick(): void {
    this.analyticsService.trackLinkClick(
      'Revisar bases legales - Súper Avance',
      this.superAdvanceCard.legalLink,
      'Product Cards - Súper Avance',
      false
    );
  }
}
